import React from "react";

const STATUS_STYLES = {
  Available: { backgroundColor: "#d4edda", color: "#155724" },
  "Pending Assessment": { backgroundColor: "#fff3cd", color: "#856404" },
  "Completed Attempts": { backgroundColor: "#f8d7da", color: "#721c24" },
};

const StatusBadge = ({ status = "Available" }) => (
  <span
    style={{
      ...STATUS_STYLES[status],
      display: "inline-block",
      minWidth: "110px",
      padding: "6px 12px",
      borderRadius: "20px",
      fontWeight: 500,
      textAlign: "center",
      whiteSpace: "nowrap",
    }}
  >
    {status}
  </span>
);

export default StatusBadge;
